import { css } from '@/styled-system/css';

export const upsellBannerContentStyles = css.raw({
  display: {
    base: 'flex',
    lg: 'inline-block',
  },
  flexDirection: {
    lgDown: 'column',
  },
  marginInlineEnd: {
    lg: 'default',
  },
});
